import { render, staticRenderFns } from "./ResumenAutoFields.vue?vue&type=template&id=734c6b9d&lang=pug&"
import script from "./ResumenAutoFields.vue?vue&type=script&lang=js&"
export * from "./ResumenAutoFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports